import axios from 'axios';
import { toast } from 'react-toastify';
import {
    IS_LOADING,
    SERIES_MANAGER_LIST_SUCCESS,
    SERIES_MANAGER_LIST_ERROR,
    SERIES_MANAGER_UPDATE_SUCCESS,
    SERIES_MANAGER_UPDATE_ERROR,
    SERIES_MANAGER_FILTER_SUCCESS,
    SERIES_MANAGER_FILTER_ERROR,
    SERIES_MANAGER_FILTER_LIST_SUCCESS,
    SERIES_MANAGER_FILTER_LIST_ERROR
} from './Type';
import { baseUrlPostGres } from '../constant';
import { apiHeader } from './ApiHeader';
import 'react-toastify/dist/ReactToastify.css';
import HandleError from '../HandleError';
import { apiVersion } from 'src/utils/apiVersion';

export const GetSeriesManagerList = (page, size, type, data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/series/${type}_team_list?page=${page}&limit=${size}`, data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: SERIES_MANAGER_LIST_SUCCESS,
                payload: response
            })
            dispatch({
                type: SERIES_MANAGER_FILTER_LIST_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: SERIES_MANAGER_LIST_ERROR,
                payload: errors
            })
            dispatch({
                type: SERIES_MANAGER_FILTER_LIST_ERROR,
                payload: errors
            })
        })
}

export const ResetGetSeriesManagerList = () => async (dispatch) => {
    dispatch({
        type: SERIES_MANAGER_LIST_SUCCESS,
        payload: {}
    })
    dispatch({
        type: SERIES_MANAGER_FILTER_LIST_SUCCESS,
        payload: {}
    })
}

export const UpdateSeriesManager = (data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/series/series_team_add`, data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: SERIES_MANAGER_UPDATE_SUCCESS,
                payload: response
            })
            dispatch(ResetUpdateSeriesManager())
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: SERIES_MANAGER_UPDATE_ERROR,
                payload: errors
            })
        })
}

export const ResetUpdateSeriesManager = () => async (dispatch) => {
    dispatch({
        type: SERIES_MANAGER_UPDATE_SUCCESS,
        payload: {}
    })
}

export const FilterSeriesManager = (type, data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/series/${type}_team`, data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: SERIES_MANAGER_FILTER_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: SERIES_MANAGER_FILTER_ERROR,
                payload: errors
            })
        })
}